// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Pastille from "../../resources/feedback-indicators/Pastille.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function ProductStockTableCell(props) {
  let formattedShopsNames = props.formattedShopsNames;
  let __size = props.size;
  let state = props.state;
  let value = props.value;
  let size = __size !== undefined ? __size : "normal";
  if (value === undefined) {
    return JsxRuntime.jsx(TextStyle.make, {
      children: "—",
      size: size
    });
  }
  let newrecord = {
    ...{
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }
  };
  let tmp;
  if (formattedShopsNames !== undefined) {
    let formattedShopsName = StringHelpers.truncateWithMiddleEllipsis(formattedShopsNames, 15);
    tmp = JsxRuntime.jsx(TextStyle.make, {
      children: formattedShopsName,
      variation: "normal",
      size: "tiny",
      maxLines: 1
    });
  } else {
    tmp = null;
  }
  newrecord.children = JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Inline.make, {
      children: [state !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(Pastille.make, {
          variant: state === "OK" ? "success" : state === "ALERT" ? "warning" : "danger"
        }), JsxRuntime.jsx(Box.make, {
          spaceRight: "xsmall"
        }), JsxRuntime.jsx(Box.make, {
          spaceRight: "xxsmall"
        })]
      }) : null, JsxRuntime.jsx(TextStyle.make, {
        children: value,
        size: size
      })],
      space: "none"
    }), tmp],
    space: "none"
  });
  return JsxRuntime.jsx("div", newrecord);
}
let make = React.memo(ProductStockTableCell);
export { make };
/* make Not a pure module */